import { useState, useEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { landingImages } from "helpers/images";
import CookiesPreferencePopup from "./CookiesPreferencePopup";

const CookiesBanner = ({ onVisibilityChange }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showPreferencePopup, setShowPreferencePopup] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  useEffect(() => {
    if (onVisibilityChange) {
      onVisibilityChange(isVisible);
    }
  }, [isVisible, onVisibilityChange]);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "true");
    setIsVisible(false);
  };

  const handleRejectNonEssential = () => {
    setShowPreferencePopup(true);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleClosePreferencePopup = () => {
    setShowPreferencePopup(false);
  };

  const handleSavePreferences = (marketingEnabled) => {
    if (marketingEnabled) {
      localStorage.setItem("cookie-consent", "true");
    } else {
      localStorage.setItem("cookie-consent", "false");
    }
    setShowPreferencePopup(false);
    setIsVisible(false);
  };

  const handleAllowAll = () => {
    localStorage.setItem("cookie-consent", "true");
    setShowPreferencePopup(false);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <>
      <div className="hidden md:block fixed z-50" />
      <div className="fixed z-50 bottom-0 w-full md:w-[360px] md:bottom-6 md:left-6 px-0">
        <div className="relative bg-yellow-50 border-t-card-width landing-md:border-card-width border-yellow-dark-600-new rounded-none md:rounded-3xl p-4 md:p-6">
          <button
            onClick={handleClose}
            className="hidden md:flex absolute -top-2 -right-3 h-8 w-8 items-center justify-center rounded-full bg-black text-white hover:bg-grey-800"
          >
            <XMarkIcon className="w-4 " />
          </button>

          <div className="flex landing-md:flex-col items-center justify-start landing-md:items-start flex-row gap-2 landing-md:gap-3">
            <img
              src={landingImages.cookieImage}
              alt="Cookies"
              className="w-6 h-6 landing-md:w-[122px] landing-md:h-[120px] mb-3"
            />

            <h3 className="text-xl landing-md:text-2xl font-bold mb-2 tracking-wide">Cookies!</h3>
          </div>

          <p className="text-xs landing-md:text-sm font-medium tracking-wide text-grey-700 mb-4">
            We use cookies to prescribe the perfect counselling information for you, to understand
            platform usage and support marketing efforts. View our{" "}
            <a href="/cookie-policy" className="underline font-medium text-black-text-color">
              Cookie Policy
            </a>{" "}
            for more info.
          </p>

          <div className="flex flex-col gap-3">
            <button
              onClick={handleAccept}
              className="w-full py-2 rounded-full bg-yellow-dark-600-new text-white font-medium hover:bg-yellow-dark-700-new"
            >
              Accept Cookies
            </button>

            <button
              onClick={handleRejectNonEssential}
              className="w-full py-2 rounded-full border border-yellow-dark-600-new text-sm font-bold hover:bg-yellow-100-new"
            >
              Reject Non-Essential
            </button>
          </div>
        </div>
      </div>
      <CookiesPreferencePopup
        show={showPreferencePopup}
        onClose={handleClosePreferencePopup}
        onSavePreferences={handleSavePreferences}
        onAllowAll={handleAllowAll}
      />
    </>
  );
};

export default CookiesBanner;
